import { useTranslation } from 'react-i18next';
import type { ContentfulArticleModel } from 'autogen/swagger/all';
import { ReadMore } from 'autogen/translation-keys/trans-website-shared-buttons';
import type { ContentCardProps } from 'components/ContentCard/types';

export default function useMapToContentCardProps(item: ContentfulArticleModel): ContentCardProps | null {
    const { t } = useTranslation();
    const { imageRatio11, section, topics, headline, link } = item;
    if (!link) return null;

    return {
        type: 'default', //type and showBorder will be changed when data comes from Contentful
        showBorder: false,
        link: {
            action: {
                $type: 'LinkActionType',
                action: link
            },
            label: t(ReadMore)
        },
        image: {
            alt: imageRatio11.altText || '',
            src: imageRatio11.url
        },
        heading: headline,
        tags: topics.map((topic) => topic.publicName),
        subheading: section.publicName
    };
}
